import {
  Component,
  computed,
  inject,
  input,
  InputSignal,
  Signal,
} from '@angular/core';

import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';

import {
  EEntityType,
  ERelationType,
  IAdditionalEntryValue,
  ITariffAdditionalEntry,
  isDateAdditionalEntry,
} from '@web/dtos';
import type { IAdditionalEntryForm } from '../../../services/shopping-cart/shopping-cart-form.service';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { DateInputComponent } from '../form-inputs/date-input/date-input/date-input.component';
import { DropDownComponent } from '../form-inputs/drop-down/drop-down.component';
import { NumberInputComponent } from '../form-inputs/number-input/number-input.component';
import { TextInputComponent } from '../form-inputs/text-input/text-input.component';

@Component({
  selector: 'aw-additional-entries-form',
  imports: [
    ReactiveFormsModule,
    DateInputComponent,
    DropDownComponent,
    NumberInputComponent,
    TextInputComponent,
    FilterTextsPipe,
    LanguagePipe,
  ],
  templateUrl: './additional-entries-form.component.html',
})
export class AdditionalEntriesFormComponent {
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERelationType: typeof ERelationType = ERelationType;

  readonly entries: InputSignal<ITariffAdditionalEntry[]> =
    input.required<ITariffAdditionalEntry[]>();
  readonly controls: InputSignal<FormArray<FormGroup<IAdditionalEntryForm>>> =
    input.required<FormArray<FormGroup<IAdditionalEntryForm>>>();

  readonly sortedEntries: Signal<ITariffAdditionalEntry[]> = computed(() =>
    [...this.entries()].sort(
      (a: ITariffAdditionalEntry, b: ITariffAdditionalEntry) =>
        a.sortOrder - b.sortOrder
    )
  );

  getValues(): IAdditionalEntryValue[] {
    return this.controls().getRawValue();
  }

  protected isDateEntry(entry: ITariffAdditionalEntry): boolean {
    return isDateAdditionalEntry(entry);
  }

  protected isDateTimeEntry(entry: ITariffAdditionalEntry): boolean {
    return this.getEntryDataType(entry) === 'DatumUhrzeit';
  }

  protected getDateErrorRelationType(
    entry: ITariffAdditionalEntry
  ): ERelationType {
    return this.isDateTimeEntry(entry)
      ? ERelationType.dateTimeInputError
      : ERelationType.dateInputError;
  }

  protected getEntryDataType(entry: ITariffAdditionalEntry): string {
    return entry.additionalEntryDataType || entry.dataType;
  }
}
